"use client";

import { BarbellVisualisation } from "@/components/numeric-keypad-plate-calc";

/**
 * Landing showcase plate-calculator visual — the REAL `BarbellVisualisation`
 * (pixel-identical to the app) loaded with a sample 140 KG, plus the plate
 * grid + target/total caption from the feature tour.
 *
 * Lives in its own `"use client"` file because `BarbellVisualisation` requires
 * an `onSelectBar` FUNCTION prop, which cannot be passed from the server
 * showcase component (functions can't cross the server→client boundary). The
 * no-op is supplied here, on the client. A single-entry `availableBars` keeps
 * the in-SVG bar-picker inert. The component is pure SVG (no fetch), so it
 * needs no mount-gating — CSS hides it on mobile at zero network cost.
 */
export function ShowcaseBarbell() {
  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center justify-between text-xs uppercase tracking-wider font-medium">
        <span className="text-fg-dim">
          Target <span className="text-fg tabular-nums">140 KG</span>
        </span>
        <span className="text-fg-dim">
          Total <span className="text-brand tabular-nums">140 KG</span>
        </span>
      </div>

      <BarbellVisualisation
        perSidePlates={[
          { denom: 25, count: 1 },
          { denom: 20, count: 1 },
          { denom: 15, count: 1 },
        ]}
        bar={20}
        unit="kg"
        availableBars={[20]}
        onSelectBar={() => {}}
      />

      {/* Plate grid — denominations + CALC %, exact IPF plate colours
          (25 red / 20 blue / 15 yellow) matching the barbell above. */}
      <div className="grid grid-cols-4 gap-1.5 text-xs font-semibold">
        {[
          { kg: "25", color: "#dc2626" },
          { kg: "20", color: "#2563eb" },
          { kg: "15", color: "#eab308" },
        ].map((p) => (
          <span
            key={p.kg}
            className="h-10 rounded-md flex flex-col items-center justify-center text-white"
            style={{ backgroundColor: p.color }}
          >
            <span className="tabular-nums">{p.kg}</span>
            <span className="text-[9px] opacity-80">KG ×1</span>
          </span>
        ))}
        <span className="h-10 rounded-md border border-brand text-brand flex items-center justify-center">
          CALC %
        </span>
      </div>
    </div>
  );
}
